module.exports = __webpack_public_path__ + "img/1724035970370-cake ultah.jpg.0b968c66.webp";